<template>
    <div class="card" v-if="crossfilterdc.visibleFlag === true" style="height: 101%">
        <div class="card-header d-flex justify-content-between">
            <div class="">{{crossfilterdc.vizTitle}}</div>
            
                <select v-model="salesmanData" class="c-s">
                    <option v-for="l1 in filterSalesman" v-bind:key="l1">{{l1}}</option>
                </select>
            <a v-on:click="commentBox(crossfilterdc)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
            </a>
        </div>
        <div class="card-body">
            <div :id="id" ref="r1c1" class='mb-1'>
                <div id='year' class='chart'>
                    <div class='title'>Revenue Wise Year-Month</div>
                </div>
                <div id='category' class='chart'>
                    <div class='title'>Revenue Wise Sub-Category</div>
                </div>
                <div id='orders' class='chart'>
                    <div class='title'>Margin Wise Count Of Orders</div>
                </div>
                <div id='salesman' class='chart'>
                    <div class='title'>Revenue Wise Sales Person</div>
                </div>

                <div class='row ml-5 mr-5 scrollbar'>
                    <table class='table table-hover' id='table-graph'>
                        <thead>
                            <tr class='header'>
                                <th>Year-Month</th>
                                <th>Salesman</th>
                                <th>Sub-Category</th>
                                <th>Count Of Orders</th>
                                <th>Revenue</th>
                                <th>Margin</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="40" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";

export default {
        name: 'Crossfilterdc',
        props: {
            crossfilterdc: Object
        },
        data: () => ({
            salesmanData:[],
            filterSalesman:'',
            showModal: false,
            cmnt: "",
            annotations: [],
            searching: false,
            annotationTitle: '',
            id: `VIZ-${new Date().getTime()}`
        }),
        methods: {
            loadSalesman: function () {
                axios.get('/api/salesman-list/')
                .then(res => {
                    this.salesmanData = res.data
                    this.filterSalesman = Array.from(new Set(this.salesmanData.map(c => c.dim1).filter(x => x != null)))
                    console.log("Salesman data:", this.filterSalesman)  
                }, err => {
                    console.log('Error in fetching record', err)
                })
            },

            commentBox: function (what) {
                console.log(`ENTERED into the commentBox function(${what.menuName}, ${what.screenName})`)
                this.cmt = '';
                this.pg = what.menuName;
                this.section = what.screenTitle;
                this.annotationHeader = "User Annotations";
                this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
                this.$refs['comment-box'].show()
            },

            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data)
                    .then(() => {
                       this.$store.dispatch('loadAnnotations')
                    }, e => {
                       // this.$commonFn.auditLog(this.crossfilterdc.menuSyspk,menu, subMenu, "", "POST", e)
                        console.error('error in updating annotations', e)
                    })
                let menu = this.pg;
                let subMenu = this.section;

                console.log("the menus and submenus for Audit log is", menu, subMenu)

               // this.$commonFn.auditLog(this.crossfilterdc.menuSyspk,menu, subMenu, "", "POST", "Success")
            },

        },
        created() {
            this.loadSalesman()
          console.log('cf-dc-2', 'load state');  this.$store.dispatch("loadState").then(() => {
                let allVizType = this.$store.state.vizType
                let v = this.crossfilterdc
                let margin = {
                    top: v.pmTop,
                    right: v.pmRight,
                    bottom: v.pmBottom,
                    left: v.pmLeft
                }
console.log("test:",v)
                let vizId = v.viztypeId
                let filter = allVizType.filter(t => t.viztypeId === vizId)[0];
                let vizname = filter.viztypeClassName
                console.log("vizName in vue",vizname)
                let vizFunction = filter.viztypeFunctionName

                let divId = this.$refs.r1c1

                let vizunit = v.positionLogical

                let getChartInfo = (vizunit) => {
                    let f = v
                    if (f.length === 0) return new FwVizChartInfo(vizunit, margin, {}, false, [])
                    return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f)
                }

                this.position = getChartInfo(vizunit)

                let chartData = this.position
                console.log("The chart data is" , chartData, vizname, divId)

                setTimeout(() => {
                    this.$commonFn.renderChart(vizname, chartData, divId, vizFunction);
                }, 300)

            })

        }
    }
</script>
<style>
    .cobackground {
        fill: #eee;
    }

    text.active {
        fill: red;
    }
    .c-s {
        margin-top: -7px;
        margin-left: 500px;
        height:30px
    }
    .chart {
        display: inline-block;
        margin-bottom: 20px;
    }
    .brush-handle {
        fill: #eee;
        stroke: #666;
    }
    #lists {
        height: 300px;
        width: 650px;
        overflow: scroll;
        background-color: white;
    }
    .scrollbar {
        height: 500px;
        overflow: scroll;
    }
</style>